<template>
  <div>
    <router-link :to="{ name: linkTarget, params: getLinkParams() }">
      {{ lemma }}
    </router-link>
  </div>
</template>

<script>
import { api } from '../mixins/api.js'

export default {
  name: 'Collocation',
  mixins: [ api ],
  props: {
    lemposString: {
      type: String,
      required: true
    },
    pattern: {
      type: String,
      required: true
    },
    coreIndexes: {
      type: Array,
      default: function () { return [] }
    },
    showCore: {
      type: Boolean,
      default: true
    },
    linkTarget: {
      type: String,
      default: 'collocation'
    }
  },
  methods: {
    getLinkParams: function () {
      if (this.linkTarget === 'collocation') {
        return { lempos: this.coreLempos, collLempos: this.lemposString, collPattern: this.pattern }
      } else if (this.linkTarget === 'grouping') {
        return {
          lempos: this.coreLempos,
          collLempos: this.lemposString,
          qualifiedPattern: this.makeQualifiedPattern(this.pattern, this.coreIndexes)
        }
      } else {
        throw new Error('Unknown link target type: ' + this.linkTarget)
      }
    }
  },
  computed: {
    lempos: function () {
      return this.lemposString.split(' ')
    },
    coreLempos: function () {
      if (this.coreIndexes.length > 0) {
        return this.lempos.filter((_, idx) => this.coreIndexes.includes(idx)).join(' ')
      }
      // Fallback: Consider first noun as core, so that linking works
      const nouns = this.lempos.filter(lp => this.lemposToPos(lp) === 'NOUN')
      if (nouns.length > 0) {
        return nouns[0]
      }
      return this.lempos[0]
    },
    lemma: function () {
      var lemmas = this.lempos.map(x => x.split('+')[0])
      if (!this.showCore) {
        lemmas = lemmas.filter((_, idx) => !this.coreIndexes.includes(idx))
      }
      return lemmas.join(' ')
    }
  }
}
</script>

<style scoped>
  div {
    padding: 5px;
    margin: 5px;
    float: right;
    border-radius: 5px;
    cursor: pointer;
  }
  a:link, a:visited {
    color:black
  }
  .router-link-active {
    color:black;
    font-weight: bold;
    font-size: 95%  /* Hack to maintain height */
  }
</style>
